<template>
    <div v-if="visible" id="premiumGalleriesSection" class="col-md-12 mb-4 premium-galleries-section profile-scroll-target">
        <div class="premium-galleries-section--close-top">
            <span @click="closeSection">&times;</span>
        </div>

        <div class="premium-galleries-grid">
            <PremiumGalleriesSectionEntryComponent
                v-for="gallery in allGalleries"
                :key="gallery.id"
                :gallery="gallery"
                :user="user"
                @viewGallery="$emit('viewGallery', $event)"
                @purchaseGallery="$emit('purchaseGallery', $event)"
            />
        </div>

        <div v-if="hasUnpurchasedGalleries" class="premium-galleries-section--actions">
            <button class="btn btn-rebrand-primary btn-rebrand-sm w-full" @click.prevent="$emit('purchaseAll')">
                {{ translate.home.purchaseAll }}
            </button>
        </div>

        <div class="premium-galleries-section--close-bottom">
            <span @click="closeSection">{{ translate.home.collapse }}</span>
        </div>
    </div>
</template>

<script>
import PremiumGalleriesSectionEntryComponent from "@/components/users/profile/partials/PremiumGalleriesSectionEntryComponent.vue";
import {scrollToElementSmooth} from "@/core/utils/helpers/scrollHelpers";

function closeSection() {
    this.$emit('close');
    this.$nextTick(() => {
        scrollToElementSmooth('#escortGallerySubscribeBlock');
    });
}

export default {
    components: {
        PremiumGalleriesSectionEntryComponent,
    },
    props: {
        user: {
            type: Object,
            default: null
        },
        visible: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapState(['translate']),
        allGalleries() {
            return _.get(this, 'user.galleries', []);
        },
        hasUnpurchasedGalleries() {
            return this.allGalleries.some(g => !g.purchased);
        }
    },
    methods: {
        closeSection,
    }
}
</script>
